var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddpatient({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4921 35.5667C28.226 35.5667 35.3062 28.4864 35.3062 19.7525C35.3062 11.0186 28.226 3.93842 19.4921 3.93842C10.7582 3.93842 3.67798 11.0186 3.67798 19.7525C3.67798 28.4864 10.7582 35.5667 19.4921 35.5667Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4922 13.4269V26.0782",
    stroke: "#845BB3",
    strokeWidth: 3.16283,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1665 19.7526H25.8178",
    stroke: "#845BB3",
    strokeWidth: 3.16283,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddpatient);
export default __webpack_public_path__ + "static/media/addpatient.822ed085885f570563a49e6d4adec044.svg";
export { ForwardRef as ReactComponent };